import styled from 'styled-components';

export const CenterDiv = styled.div`
  display: grid;
  justify-content: center;
`;



// WEBPACK FOOTER //
// ./src/CenterDiv.js